import { useIntl } from 'react-intl'
import { Tooltip, Box } from '@mui/material'
import CartoUserAvatar from 'features/users/ui/CartoUserAvatar'
import Gravatar from 'features/common/ui/utils/Gravatar'
import { getAvatarData } from 'features/users/model/user'

interface CardOwnerAvatarProps {
  picture?: string
  email?: string
  cartoUser?: boolean
}

function CardOwnerAvatar({ picture, email, cartoUser }: CardOwnerAvatarProps) {
  const intl = useIntl()
  const userEmail = cartoUser ? intl.formatMessage({ id: 'account.supportAccess.userEmail' }) : email
  const tooltipTitle = email ? intl.formatMessage({ id: 'common.cards.createdByOwner' }, { owner: userEmail }) : ''
  const { acronym } = getAvatarData({ name: email })

  if (!picture) return null

  return (
    <Tooltip title={tooltipTitle}>
      <Box>
        {cartoUser ? (
          <CartoUserAvatar size="xsmall" />
        ) : (
          <Gravatar size="xsmall" acronym={acronym} alt={tooltipTitle} userImage={picture} email={email} />
        )}
      </Box>
    </Tooltip>
  )
}

export default CardOwnerAvatar
